module.exports = {
	"articleTitle1": "Obama takes the stage to a crowd estimated to total 9000 in Ann Arbor",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Ray Fisher Stadium",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/baseball/lugbauers-barrage-powers-michigans-recent-surge",
	"articleSnippet1": "Nov 7, 2016 ... President Obama campaigns for Hillary Clinton at the Ray L. Fisher Stadium in \nAnn Arbor on Monday. Grant Hardy/ Daily. Caitlin Reedy.",
	"articleSnippet2": "Apr 5, 2017 ... A return to Ray Fisher Stadium was seemingly all that was needed for Lugbauer \nto find his form.",
	"totalMisc": 0,
	"articleTitle2": "Lugbauer's surge powers Michigan's offense ",
	"address": "1114 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161111/gbh.NEW_.Obama_.11.7.16.1444.jpg?itok=27d_XlqS",
			"author": "Grant Hardy",
			"caption": "President Obama campaigns for then-Democratic presidential candidate Hillary Clinton at the Ray L. Fisher Stadium in Ann Arbor on Monday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170320/aar.BBL_.vsNIU_.3.19.17.393.jpg?itok=IeqZbJS2",
			"author": "Aaron Baker",
			"caption": "Michigan coach Erik Bkaich's pitching staff is still in the process of establishing itself leading up to conference play."
		}
	],
	"position": {
		"lat": 42.26748,
		"lng": -83.742664
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/rayfisherstadium.json
// module id = 958
// module chunks = 0